import { createFileRoute } from '@tanstack/react-router'
import { HomePage } from '@/pages/HomePage'
import { ROUTES } from '@/constants/routeConstants.ts'

const App = () => {
  return <HomePage />
}

export const Route = createFileRoute(ROUTES.ROOT)({
  staticData: {
    headerLight: true,
  },
  component: App,
})
